module.exports = __webpack_public_path__ + "static/media/74_scratch_metal_seamless.14988830.jpg";